var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4581 7.58621C21.4581 11.776 17.9646 15.1724 13.6552 15.1724C9.34572 15.1724 5.85222 11.776 5.85222 7.58621C5.85222 3.39646 9.34572 0 13.6552 0C17.9646 0 21.4581 3.39646 21.4581 7.58621Z",
    fill: "#C4CAD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6552 19.7241C6.11363 19.7241 0 25.6679 0 33V38.25H27.3103V33C27.3103 25.6679 21.1967 19.7241 13.6552 19.7241Z",
    fill: "#C4CAD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.3a52d50ae7e2408ecb56f051fc030345.svg";
export { ForwardRef as ReactComponent };